import { QUERY, useSuspenseQueryOperation } from 'api/Query';
import type { Callback } from 'ts/base/Callback';
import { TaskTable } from 'ts/perspectives/quality_control/tasks/dialog/TaskSelectionDialogTable';
import type { SimpleTask } from 'typedefs/SimpleTask';

type FindingTaskSelectionDialogProps = {
	tasks: SimpleTask[];
	projectId: string;
	onSelectTask: Callback<number>;
};

/** Task table for tasks in findings table */
export function FindingTaskSelectionDialog({ tasks, projectId, onSelectTask }: FindingTaskSelectionDialogProps) {
	const taskIds = tasks.map(simpleTask => simpleTask.id);

	const resolvedTasks = useSuspenseQueryOperation(QUERY.getResolvedTasks(projectId, { ids: taskIds }));
	return <div>{tasks.length > 0 ? <TaskTable tasks={resolvedTasks} onSelectTask={onSelectTask} /> : null}</div>;
}
